export enum OrderShippingLineState {
  All = 0,
  MissingOnly = 1,
  PresentOnly = 2
}